import { cn } from '@bem-react/classname';

export const cnImage = cn('Image');
